export const camera = {
  title: 'Camera',
  resetDefaultCamera: 'Return to default camera',
  addNewCamera: 'Add new camera view',
  addCamera: 'Add shot',
  addLocalCamera: 'Add local',
  addGlobalCamera: 'Add global',
  createdCamera: 'Camera created',
  newCameraNotSaved: 'A newly created, unsaved camera exists',
  editCameraSettings: 'Edit settings',
  cancelCameraSettings: 'Cancel editing',
  removeCamera: 'Delete shot',
  removeGlobalCamera: 'Delete global shot',
  removedCamera: 'Camera deleted',
  savedChanges: 'Changes saved',
  saveCameraSettings: 'Save changes',
  viewCamera: 'Camera preview',
  viewCameraTooltip: 'Preview shot',
  editCameraTooltip: 'Edit shot',
  newCameraTitle: 'New shot',
  editCameraTitle: 'Edit shot',
  noCamerasFound: 'No saved cameras found',
  noGlobalCameras: 'No global shots',
  allGlobalCamerasInUse: 'All global shots are used in this flow',
  notUsedInFlow: 'Not used in flow',
  otherCameras: 'Other cameras',
  selectIcon: 'Select icon',
  labelLabel: 'Camera name',
  codeLabel: 'Code',
  descriptionLabel: 'Camera description',
  inactiveCamera: 'Camera inactive',
  activeCamera: 'Camera active',
  enableCamera: 'Enable shot',
  disableCamera: 'Disable shot',
  cameraActivated: 'Camera activated',
  cameraDeactivated: 'Camera deactivated',
  cameraIsDefault: 'This camera is default',
  setCameraAsDefault: 'Set as default camera',
  unsetDefault: 'Remove default designation',
  cameraSetDefault: 'Camera set as default',
  cameraRemovedFromDefault: 'Removed from default cameras',
  cameraSetAsDefault: 'Shot set as default for this flow',
  cameraUnsetAsDefault:
    'Shot removed from default. Assign another shot as default or leave the flow without a default shot.',
  cameraDetachedFromFlow: 'Shot detached from flow',
  cameraAttachedToFlow: 'Shot attached to flow',
  attachToFlow: 'Attach to flow',
  detachFromFlow: 'Detach from flow',
  duplicateGlobally: 'Duplicate globally',
  duplicateLocally: 'Duplicate locally',
  copyToLocal: 'Copy to local',
  copyToGlobal: 'Copy to global',
  globalScope: 'Global',
  localScope: 'Local',
  globalCameraScopeTooltip: 'Shared shot. Changes affect all linked flows.',
  localCameraScopeTooltip: 'Local shot for this flow only.',
  editGlobalCameraTitle: 'Edit global shot',
  editGlobalCameraDescription:
    'This change will affect all configurations. Are you sure you want to continue?',
  deleteGlobalCameraTitle: 'Delete global shot',
  deleteGlobalCameraDescription:
    'A global shot can only be deleted if it is not used in a published flow.',
  globalCameraNotEditable:
    'This global shot is used in already published configurations and cannot be edited.',
  globalCameraNotDeactivatable:
    'This global shot is used in already published configurations and cannot be deactivated.',
  globalCameraNotDeletable:
    'This global shot is used in already published configurations and cannot be deleted.',
  onlyLocalCamerasCanBeDefault:
    'Only local shots can be set as default for a flow.',
  saveCameraBeforeDefault: 'Save the shot first to set it as default.',
  saveCameraBeforeCopy: 'Save the shot first to copy it.',
  saveCameraBeforeAssign: 'Save the shot first to attach / detach it.',
  cannotEditDisabled: 'Cannot edit a disabled shot. Enable it first.',
  cannotSetDisabledAsDefault:
    'Cannot set a disabled shot as default. Enable it first.',
}
